// extracted by mini-css-extract-plugin
export default {"pill":"PriorityPill_pill__uAjB1","high":"PriorityPill_high__WNYNJ","medium":"PriorityPill_medium__nxtiv","low":"PriorityPill_low__8CZHx"};